import React, { useEffect, useState } from "react";
import { FaPiggyBank } from "react-icons/fa";
import Input from "../../../../../components/Input";
import Popup from "../../../../../components/Popup";
import bankAccountServices from "../../../../../services/admFin/bankAccountServices";
import bankAccountTransferServices from "../../../../../services/admFin/bankAccountTransferServices";



export default function BankAccountTransferPopUp(props) {
    const [contaOrigem, setContaOrigem] = useState("");
    const [contaDestino, setContaDestino] = useState("");
    const [data, setData] = useState("");
    const [valor, setValor] = useState("");
    const [descricao, setDescricao] = useState("");

    const contas = props.bankAccounts;

    async function onTransfer() {
        try {
            if(!contaDestino || !contaOrigem || !data || !valor || !descricao) {
                alert("Todos os campos obrigatórios devem ser preenchidos");
                return;
            }
            const response = await bankAccountTransferServices.postBankAccountTransfer(Number(contaOrigem.split(":")[0]), Number(contaDestino.split(":")[0]), valor, data, descricao);
            props.getBankAccounts();
            props.setBankAccountTransfers(oldArray => {
                const temp = [...oldArray]
                temp.unshift(response.data);
                return temp;
            });
            props.setVisibility(false);
            cleanStates();
        }
        catch(err) {
            alert(err);
        }
    }

    function cleanStates() {
        setContaOrigem("");
        setContaDestino("");
        setValor("");
        setData("");
        setDescricao("");
    }


    return (
        <Popup
            icon={<FaPiggyBank />}
            tittle="Transferência Bancária"
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <Input
                label="Conta bancária origem*"
                type='select'
                options={contas ? 
                        contas.map(item => `${item.id}: ${bankAccountServices.formatBankAccount(item)}`) : []
                }
                id='popup-new-transfer-bank-account-origin'
                onChange={(event) => setContaOrigem(event.target.value)}
                value={contaOrigem}
            />

            <Input
                label="Conta bancária destino*"
                type='select'
                options={contas ? 
                        contas.map(item => `${item.id}: ${bankAccountServices.formatBankAccount(item)}`) : []
                }
                id='popup-new-transfer-bank-account-destiny'
                onChange={(event) => setContaDestino(event.target.value)}
                value={contaDestino}
            />
            
            <Input
                label="Valor*"
                type="currency"
                placeholder="Digite o valor transferido da conta origem para a destino"
                id="new-bank-account-transfer-popup-value"
                onChange={(e) => setValor(String(e.target.value).replace(/,/g, '.'))}
                value={valor}
            />

            <Input
                label="Data da transferência*"
                type='date'
                id='popup-new-bank-account-transfer-date-payment'
                onChange={(event) => {
                    setData(event.target.value);
                }}
                value={data}
            />

            <Input
                label='Descrição*'
                placeholder="Insira uma descrição"
                type='textarea'
                id='popup-new-bank-account-transfer-description'
                onChange={(event) => setDescricao(event.target.value)}
                value={descricao}
            />

            <button onClick={() =>{
                onTransfer()
            }}>Transferir</button>
        </Popup>
    )
}